export var ACTION;
(function (ACTION) {
    ACTION["DASHBOARD"] = "DASHBOARD";
    ACTION["PROFILE"] = "PROFILE";
    ACTION["WITHDRAW"] = "WITHDRAW";
    ACTION["REPAYMENT"] = "REPAYMENT";
    ACTION["MENU"] = "MENU";
    ACTION["CONTACT_US"] = "CONTACT_US";
    ACTION["TRANSACTION"] = "TRANSACTION";
    ACTION["STATUS"] = "STATUS";
    ACTION["LEARN_MORE"] = "LEARN_MORE";
    ACTION["RENEW_NOW"] = "RENEW_NOW";
    ACTION["LOAN_EXPIRED_REPAYMENT"] = "LOAN_EXPIRED_REPAYMENT";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["INTEREST_REPAYMENT_DETAILS"] = "INTEREST_REPAYMENT_DETAILS";
    ACTION["LEARN_MORE_INTEREST"] = "LEARN_MORE_INTEREST";
    ACTION["REOPEN_LOAN_ACCOUNT"] = "REOPEN_LOAN_ACCOUNT";
    ACTION["SHORTFALL_DETAILS"] = "SHORTFALL_DETAILS";
    ACTION["NAVIGATE_TO_SHORTFALL_INFO_SCREEN"] = "NAVIGATE_TO_SHORTFALL_INFO_SCREEN";
    ACTION["NAVIGATE_ACCOUNT_DETAILS"] = "NAVIGATE_ACCOUNT_DETAILS";
    ACTION["NAVIGATE_TRANSACTION_DETAILS"] = "NAVIGATE_TRANSACTION_DETAILS";
    ACTION["NAVIGATE_MANAGE_LIMIT"] = "NAVIGATE_MANAGE_LIMIT";
    ACTION["NAVIGATE_TRACK_LOAN_CLOSURE"] = "NAVIGATE_TRACK_LOAN_CLOSURE";
    ACTION["NAV_TO_IC"] = "NAV_TO_IC";
    ACTION["NAVIGATE_TO_WITHDRAWAL_SCREEN"] = "NAVIGATE_TO_WITHDRAWAL_SCREEN";
    ACTION["WITHDRAWAL_REJECTION_TRANSACTION_HISTORY"] = "WITHDRAWAL_REJECTION_TRANSACTION_HISTORY";
    ACTION["CLOSE_SDK_PROCESS_COMPLETE_CARD"] = "CLOSE_SDK_PROCESS_COMPLETE_CARD";
    ACTION["ON_WITHDRAW_CLICK_ACTION"] = "ON_WITHDRAW_CLICK_ACTION";
    ACTION["BACK_BUTTON"] = "BACK_BUTTON";
    ACTION["REFUND_LOAN"] = "REFUND_LOAN";
})(ACTION || (ACTION = {}));
export var CreditDisbursalStatus;
(function (CreditDisbursalStatus) {
    CreditDisbursalStatus["APPROVED"] = "APPROVED";
    CreditDisbursalStatus["REQUESTED"] = "REQUESTED";
    CreditDisbursalStatus["REJECTED"] = "REJECTED";
    CreditDisbursalStatus["SETTLED"] = "SETTLED";
})(CreditDisbursalStatus || (CreditDisbursalStatus = {}));
